import { useMutation } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { updateProduct } from '../../services/products';

interface Options {
  onError?: (message: string) => void;
}

/** Sets taxability on every variant of a product at once. */
function useSetProductTaxable({ onError }: Options = {}) {
  const { user } = useUser();

  return useMutation({
    mutationFn: async ({
      productId,
      isTaxable,
    }: {
      productId: string;
      isTaxable: boolean;
    }) => {
      const businessId = user?.business?.id;
      if (!businessId) throw new Error('No business ID found');
      return updateProduct(productId, businessId, { isTaxable });
    },
    onError: () => onError?.('Failed to update taxable'),
  });
}

export default useSetProductTaxable;
